import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { matchPath } from '../../utils/reactRouterCompatibility';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import Link from '../../common/typography/Link';
import { hideMenu } from '../../../store/actions/CommonAction';

const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: prop => prop !== 'nested'
})(({ theme, nested }) => ({
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
    transition: 'all 0.15s ease-in-out',
    ...(nested && {
        paddingLeft: theme.spacing(4),
    }),
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
    },
    '&.Mui-selected': {
        backgroundColor: 'rgba(255, 145, 0, 0.12)',
        '&:hover': {
            backgroundColor: 'rgba(255, 145, 0, 0.18)',
        },
        '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
        },
        '& .MuiListItemText-primary': {
            color: theme.palette.primary.main,
            fontWeight: 500,
        },
    },
    '&.Mui-disabled': {
        opacity: 0.4,
    },
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    minWidth: 36,
    color: 'rgba(255, 255, 255, 0.7)',
    '& svg': {
        fontSize: '1.25rem',
    },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    '& .MuiListItemText-primary': {
        fontSize: '0.875rem',
        fontWeight: 400,
    },
}));

const ListItemNavLink = (props) => {
    const { icon, primary, path, tooltip, disabled, nested } = props;

    const dispatch = useDispatch();
    const location = useLocation();
    const handleHideMenu = () => dispatch(hideMenu());

    const renderLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => (
                <Link ref={ref} to={path} {...linkProps} />
            )),
        [path],
    );

    const patternPath = props.path || '';
    const match = patternPath ? matchPath(patternPath, location.pathname) : null;
    const selected = !!match;

    return (
        <Tooltip title={tooltip || ''} placement="right" arrow>
            <StyledListItemButton
                component={renderLink}
                selected={selected}
                disabled={disabled}
                onClick={handleHideMenu}
                nested={nested}
            >
                {icon && <StyledListItemIcon>{icon}</StyledListItemIcon>}
                <StyledListItemText primary={primary} />
            </StyledListItemButton>
        </Tooltip>
    );
};

export default ListItemNavLink;